import { SourcePreviewAuthor } from "#features/conversations/components/conversation-source/source-preview/SourcePreviewAuthor.tsx";
import { SourcePreviewDescription } from "#features/conversations/components/conversation-source/source-preview/SourcePreviewDescription.tsx";
import { SourcePreviewFooter } from "#features/conversations/components/conversation-source/source-preview/SourcePreviewFooter.tsx";
import { SourcePreviewHeader } from "#features/conversations/components/conversation-source/source-preview/SourcePreviewHeader.tsx";
import { SourcePreviewTitle } from "#features/conversations/components/conversation-source/source-preview/SourcePreviewTitle.tsx";
import type { ConversationSource } from "#types/types.ts";
import type { ReactElement } from "react";
import "#css/ink.css";
import "./SourcePreview.css";

interface Props {
    source: ConversationSource;
    title: string;
    titleIcon?: ReactElement;
    author: string | null;
    date: string | null;
    description: string;
    /** Replaces the app's name in the header and the footer (a web page names its site). */
    appName?: string | null;
    /** Replaces the app's colour tile (a web page shows its favicon). */
    tile?: ReactElement;
}

export const SourcePreview = ({ source, title, titleIcon, author, date, description, appName, tile }: Props) => {
    return (
        <div className="wai-source-card">
            <SourcePreviewHeader source={source} date={date} appName={appName} tile={tile} />
            <SourcePreviewTitle text={title} icon={titleIcon} />
            {author && <SourcePreviewAuthor author={author} />}
            {description && <SourcePreviewDescription description={description} />}
            <SourcePreviewFooter source={source} appName={appName} />
        </div>
    );
};
